__turbopack_context__.v({
  "body": "grid-module__qTxVQG__body",
  "cell": "grid-module__qTxVQG__cell",
  "column": "grid-module__qTxVQG__column",
  "grid": "grid-module__qTxVQG__grid",
  "header": "grid-module__qTxVQG__header",
  "headerLine": "grid-module__qTxVQG__headerLine",
  "headers": "grid-module__qTxVQG__headers",
  "row": "grid-module__qTxVQG__row",
});
